import { useLazyQuery } from "@apollo/client/react";import { useEffect, useState } from "react";
import { GET_AUTORIZACIONES_CAMBIOS_PRECIO } from "../../../data/graphQL/queries/AutCambioPrecio/getAutorizacionesCambioPrecio";


export const useGetRows = (filter, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);

  const [getAutorizaciones, { data: dataAutorizaciones, loading: loadingRows }] = useLazyQuery(GET_AUTORIZACIONES_CAMBIOS_PRECIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataAutorizaciones || loadingRows) return;
    const dataAdapted = dataAutorizaciones?.autorizacionesCambioPrecio?.valorEsperado?.map((autorizacion) => ({
      ...autorizacion,
      idEvaluacion: +autorizacion?.idEvaluacion
    })) || [];
    setRows(dataAdapted);
    setIsRefetchRequired(false);
  }, [dataAutorizaciones]);

  const handleSearch = () => {
    getAutorizaciones({
      variables: {
        filter:
        {
          ...filter,
          idDelegacion: filter.idDelegacion === -1 ? 0 : filter.idDelegacion
        }
      }
    });
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return {
    rows,
    setRows,
    loading: loadingRows,
    totalCount: rows.length || 0,
    handleSearch
  };

};